import {
  USER_INFO, ADD_TO_NETWORK, EDIT_SPAM_LIST,
  UNANSWERED_NETWORK_REQUEST_COUNT, DECREMENT_UNANSWERED_NETWORK_REQUEST_COUNT,
  RESET,
} from './types';

export default {
  [USER_INFO]: (state, { info }) => {
    const user = info;
    user.last_name = info.user.last_name;
    user.first_name = info.user.first_name;
    user.email = info.user.email;
    user.customer_id = info.user.customer_id;
    state.userInfo = user;
  },
  [ADD_TO_NETWORK]: (state, { userNetwork }) => {
    state.userNetwork = [...state.userNetwork, userNetwork];
  },
  [EDIT_SPAM_LIST]: (state, { customer_id, action }) => {
    let { userInfo: { spam_list } } = state;
    if (action === 'add') spam_list.push(customer_id);
    if (action === 'remove') {
      spam_list = spam_list.filter(id => id !== customer_id);
    }
    state.userInfo.spam_list = spam_list;
  },
  [UNANSWERED_NETWORK_REQUEST_COUNT]: (state, { count }) => {
    state.unansweredNetworkRequestCount = count;
  },
  [DECREMENT_UNANSWERED_NETWORK_REQUEST_COUNT]: (state) => {
    state.unansweredNetworkRequestCount -= 1;
  },
  [RESET]: (state) => {
    state.userInfo = {};
    state.userNetwork = [];
    state.unansweredNetworkRequestCount = 0;
  },
};
